import { GetterTree } from 'vuex'
import { ShareState } from '@/store/share/types'
import { RootState } from '@/store/types'

const getters: GetterTree<ShareState, RootState> = {}

export default getters
